// axiosConfig.js
import axios from "axios"

// Create an instance of axios with default properties
const axiosInstance = axios.create({
  baseURL: "https://managers-testing.ew.r.appspot.com/", // Your API base URL
  // You can add more default settings here
})

export default axiosInstance
